import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const ListEdit = ({
  className,
  color = '#fff',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      focusable="false"
      aria-hidden="true"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M3 6v2h16V6H3Zm0 4v2h11v-2H3Zm17 .1c-.1 0-.3.1-.4.2l-1 1 2.1 2.1 1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2Zm-1.9 1.8-6.1 6V20h2.1l6.1-6.1-2.1-2ZM3 14v2h8v-2H3Z"
        fill={color}
      />
    </svg>
  );
};
